var map = {
	"./EI_logo.svg": 2820,
	"./Isanur_img.png": 7838,
	"./address_image.svg": 3906,
	"./animated_ashutosh.png": 8009,
	"./animated_logo.svg": 9083,
	"./atg_logo.svg": 6696,
	"./banao_logo.png": 933,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./ghc_logo.png": 7140,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./intel_logo.jpg": 8504,
	"./iu_logo.png": 6056,
	"./jsFramework.svg": 9655,
	"./kaggle_logo.png": 2819,
	"./legato_logo.png": 1236,
	"./manOnTable.svg": 7473,
	"./microsoft_logo.png": 752,
	"./mozilla_logo.png": 6816,
	"./muffito_logo.png": 9556,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./saayaHealthLogo.png": 4176,
	"./stanford_logo.png": 6691,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./tiktok_logo.png": 3292,
	"./ui_ux_design.svg": 9163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;